import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { formatAmount } from "../../common/StyledComponents/StyledFields";
import { useEffect, useRef, useState } from "react";
import Pagination from "../../common/pagination/pagination";
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";
import { position } from "html2canvas/dist/types/css/property-descriptors/position";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",
    whiteSpace:"nowrap",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const PoojaReportsTableData = (props: any) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [tableHeaders, setTableHeaders] = useState<any>(props.tableHeaders);
  const [reportData, setReportData] = useState<any>(props.ReportData);
  const [totalAmounts, setTotalAmounts] = useState<any>(
    props.totalAmounts_PoojaBooking
  );

  useEffect(() => {
    setTotalRecords(props.totalRecords);
    setTotalAmounts(props.totalAmounts_PoojaBooking);
  }, []);

  const prevPageNumber = usePrevious(pageNumber);
  function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }

  useEffect(() => {
    if (prevPageNumber !== undefined && prevPageNumber !== pageNumber) {
      searchDataApi();
    }
  }, [pageNumber, prevPageNumber]);

  const searchDataApi = () => {
    let reqBody = props.poojaReqBody;
    reqBody.pageNumber = pageNumber;
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/pooja/POOJA_BOOKING_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res?.data?.[0]?.totalElements);
        const totalAmounts = res?.data?.[0]?.data?.pop();
        setTotalAmounts(totalAmounts);
        const response = res?.data?.[0]?.data?.map((report: any) => {
          return {
            "Receipt No.": report.receiptnumber,
            "Reference No.": report.id,
            "Receipt Date": report.dateofpoojabooking,
            "Mode of Payment": report.modeofpayment,
            "Check Number/Account Holder Name": report.checknumber,
            "Date of transaction": report.transactiondate,
            "Devotee Name(Sign-in Name)": `${report.firstname} ${report.lastname} (${report.username})`,
            "Pooja Name": report.poojaname,
            "Priest Name(Sign-in Name)": report.priest,
            "Pooja Date": report.poojadate,
            "Priest Selected By(Sign-in Name)":
              report.priest_selectedby || "--",
            "Donation Amount": formatAmount(report.amount),
            "Refund Amount": formatAmount(report.refundamount),
            "Refund Date": report.refunddate,
            "Refund Reason": report.reasonforrefund,
            "Refund Check Number": report.refund_checknumber,
          };
        });
        setReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <>
      {reportData.length === 0 && (
        <Typography
          sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}
        >
          <b>No Records found</b>
        </Typography>
      )}
      <StyledTableContainer sx={{ width: "100%" }}>
        <StyledTable aria-label="customized table">
          <TableHead>
            <TableRow>
              {Object.values(tableHeaders).map((header: any) => (
                <StyledTableCell align="center" key={header}>
                  <div
                    style={{ textTransform: "capitalize" }}
                    dangerouslySetInnerHTML={{ __html: header }}
                  />
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
          {loading && (
              <div
                style={{
                  position: "sticky",
                  top: "50%",
                  zIndex: "999",
                  textAlign: "center",
                  marginLeft:"500px"
                }}
              >
                <ClipLoader color="#000" loading={loading} size={25} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                ></span>
              </div>
            )}
            {reportData?.map((item: any, index: any) => (
              <StyledTableRow key={index}>
                {Object.keys(props.tableHeaders).map((column) => (
                  <StyledTableCell key={column}>
                    <div dangerouslySetInnerHTML={{ __html: item[column] }} />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
            {props.ReportName === "Pooja Booking summary by sign-in name" && (
              <StyledTableRow style={{ backgroundColor: "#F2BE22" }}>
                <StyledTableCell>
                  <div
                    style={{
                      textTransform: "capitalize",
                      alignItems: "flex-start",
                      verticalAlign: "top",
                    }}
                    dangerouslySetInnerHTML={{ __html: "Total" }}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      textTransform: "capitalize",
                      alignItems: "flex-end",
                      verticalAlign: "top",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: props.totalPooajs,
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      textTransform: "capitalize",
                      alignItems: "flex-end",
                      verticalAlign: "top",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: props.totalTime,
                    }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
  
      {props.ReportName === "Pooja Booking Report" &&
        props.ReportData.length !== 0 && (
          <>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                marginTop: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Amount" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(totalAmounts.grandtotal),
                }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Refund" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(totalAmounts.refundamount),
                }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Amount" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(totalAmounts.remaining_after_refund),
                }}
              />
            </div>
          
          {props.ReportName === "Pooja Booking Report" &&
            totalRecords > 20 ? (
              <div
              className="no_print"
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              >
                <Pagination
                  items={totalRecords}
                  itemsPerPage={20}
                  setPageNumber={setPageNumber}
                  pageNumber={pageNumber}
                />
              </div>
            ) : (
              ""
            )}
          </>
        )}
    </>
  );
};

export default PoojaReportsTableData;
